import React, { useState } from "react"
import clsx from "clsx"
import pluralize from "pluralize"

import { Asset, Flag, Icon, Link } from "components"

function Post({ active, category, href, image, title, sliderRef }) {
  const [isHovering, setIsHovering] = useState(false)

  return (
    <article className="h-full px-3 sm:px-fluidMargin md:px-4 lg:px-10 xl:px-14">
      <Link
        href={href}
        className="flex flex-col h-full text-darkNavy focus:text-violet"
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        onClick={e => {
          if (sliderRef?.current) {
            if (active) {
            } else {
              if (e.clientX < window.innerWidth / 2) {
                sliderRef.current.slickPrev()
              } else {
                sliderRef.current.slickNext()
              }
              e.preventDefault()
            }
          }
        }}
      >
        <div className="aspect-w-5 aspect-h-4 md:aspect-w-8 md:aspect-h-5">
          <div className="absolute top-0 left-0 w-full h-full z-card-bg bg-mineralGray" />
          {image && (
            <Asset
              asset={image}
              objectFit="cover"
              objectPosition="center"
              className="!absolute z-card-bg"
            />
          )}
          {category && (
            <div className="flex items-end transform translate-x-6 z-flag md:translate-x-8">
              <Flag
                label={pluralize.singular(category?.name)}
                appearance="primary"
              />
            </div>
          )}
        </div>
        <div className="flex flex-col justify-between flex-1 p-6 space-y-6 bg-white md:p-8 md:space-y-8">
          <p className="text-current h4">{title}</p>
          <div
            className={clsx(
              "flex items-center justify-center transform transition-transform ease-out duration-300 w-6 h-6",
              isHovering === true && "translate-x-2"
            )}
          >
            <Icon
              aria-hidden
              className="text-violet"
              symbol="arrow-right"
              size={24}
            />
          </div>
        </div>
      </Link>
    </article>
  )
}

export default Post
